import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { EyeIcon, MicIcon } from 'lucide-react';
export function RoleSelect() {
  const navigate = useNavigate();
  const goRegister = (role: 'viewer' | 'comedian') => {
    navigate(`/auth/register?role=${role}`);
  };
  return <div className="w-full h-full bg-black relative overflow-hidden flex flex-col" data-id="element-312">
      {/* Background scene (abstract, on-brand) */}
      <div className="absolute inset-0" data-id="element-313">
        {/* Spotlight gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-surface2 via-black to-black" data-id="element-314" />
        <motion.div animate={{
        opacity: [0.4, 0.6, 0.4],
        scale: [1, 1.05, 1]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute -top-20 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-primary/20 rounded-full blur-3xl" data-id="element-315" />
        <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black via-black/80 to-transparent" data-id="element-316" />

        {/* Floating emoji crowd */}
        <motion.div animate={{
        y: [0, -12, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-[18%] left-8 text-5xl opacity-80 drop-shadow-2xl" data-id="element-317">
          😂
        </motion.div>
        <motion.div animate={{
        y: [0, -16, 0],
        rotate: [-6, 6, -6]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.5
      }} className="absolute top-[12%] right-10 text-6xl opacity-90 drop-shadow-2xl" data-id="element-318">
          🎤
        </motion.div>
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 4.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute top-[28%] right-24 text-4xl opacity-70 drop-shadow-2xl" data-id="element-319">
          🤣
        </motion.div>
        <motion.div animate={{
        y: [0, -8, 0],
        rotate: [4, -4, 4]
      }} transition={{
        duration: 3.8,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.8
      }} className="absolute top-[34%] left-16 text-3xl opacity-60 drop-shadow-2xl" data-id="element-320">
          🎭
        </motion.div>

        {/* Stage floor */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-primary/10 to-transparent" data-id="element-321" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex flex-col px-6 pb-8" data-id="element-322">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex-1 flex flex-col items-center justify-center text-center" data-id="element-323">
          {/* Icon */}
          <div className="w-16 h-16 rounded-2xl bg-primary/15 border border-primary/30 flex items-center justify-center mb-6 backdrop-blur-sm" data-id="element-324">
            <span className="text-4xl" data-id="element-325">🎭</span>
          </div>

          <h1 className="text-3xl font-poppins font-extrabold text-white mb-3 leading-tight" data-id="element-326">
            Join the Haus
          </h1>
          <p className="text-softGray text-sm max-w-xs leading-relaxed" data-id="element-327">
            Tell us how you'll be having fun. You can switch this up later.
          </p>
        </motion.div>

        {/* Actions */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.15
      }} className="flex flex-col gap-3" data-id="element-328">
          <button onClick={() => goRegister('viewer')} className="w-full bg-white/5 hover:bg-white/10 border border-white/30 rounded-2xl py-4 flex items-center justify-center gap-3 text-white font-bold transition-colors backdrop-blur-sm" data-id="element-329">
            <EyeIcon size={20} data-id="element-330" />
            Sign up as a Viewer
          </button>

          <button onClick={() => goRegister('comedian')} className="w-full bg-primary hover:bg-primary/90 rounded-2xl py-4 flex items-center justify-center gap-3 text-black font-bold transition-colors shadow-[0_4px_20px_rgba(255,212,0,0.3)]" data-id="element-331">
            <MicIcon size={20} data-id="element-332" />
            Sign up as a Comedian
          </button>

          <button onClick={() => navigate('/feed')} className="w-full bg-transparent border border-white/15 hover:border-white/30 rounded-2xl py-4 text-white font-medium transition-colors" data-id="element-333">
            Continue as Guest
          </button>

          <p className="text-center text-sm text-softGray mt-4" data-id="element-334">
            I already have an account{' '}
            <button onClick={() => navigate('/auth/login')} className="text-white font-bold hover:text-primary transition-colors" data-id="element-335">
              Login
            </button>
          </p>
        </motion.div>
      </div>
    </div>;
}